"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCancellationItem = addCancellationItem;
exports.approveCancellation = approveCancellation;
exports.confirmRecharge = confirmRecharge;
exports.deleteMember = deleteMember;
exports.deleteXyUserAddress = deleteXyUserAddress;
exports.exportMembers = exportMembers;
exports.exportRechargeRecords = exportRechargeRecords;
exports.exportUserAddresses = exportUserAddresses;
exports.getCancellationList = getCancellationList;
exports.getImagePrefix = getImagePrefix;
exports.getMemberById = getMemberById;
exports.insertMember = insertMember;
exports.memberExchange = memberExchange;
exports.memberRecharge = memberRecharge;
exports.payRecharge = payRecharge;
exports.retMoney = retMoney;
exports.retRecharge = retRecharge;
exports.searchUserByPhone = searchUserByPhone;
exports.sendCoupon = sendCoupon;
exports.syncMember = syncMember;
exports.unbindMember = unbindMember;
exports.unbindOpenId = unbindOpenId;
exports.updateMember = updateMember;
exports.uploadAvatar = uploadAvatar;
exports.vipCouponInfo = vipCouponInfo;
exports.xyBonusLogPage = xyBonusLogPage;
exports.xyUserAccountLogPage = xyUserAccountLogPage;
exports.xyUserAccountPage = xyUserAccountPage;
exports.xyUserActionPage = xyUserActionPage;
exports.xyUserAddressPage = xyUserAddressPage;
exports.xyUserCouponBatchPage = xyUserCouponBatchPage;
exports.xyUserExtendPage = xyUserExtendPage;
exports.xyUsersPage = xyUsersPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取会员列表
function xyUsersPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/page',
    method: 'get',
    params: query
  });
}

// 新增会员
function insertMember(data) {
  return (0, _requestAuth.default)({
    url: '/xyUsers',
    method: 'post',
    data: data
  });
}

// 编辑会员
function updateMember(data) {
  return (0, _requestAuth.default)({
    url: '/xyUsers',
    method: 'put',
    data: data
  });
}

// 删除会员
function deleteMember(userId) {
  return (0, _requestAuth.default)({
    url: '/xyUsers',
    method: 'delete',
    params: {
      userId: userId
    }
  });
}

// 通过id查询会员详情
function getMemberById(id) {
  return (0, _requestAuth.default)({
    url: "/xyUsers/".concat(id),
    method: 'get'
  });
}

// 会员充值
function memberRecharge(data) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/recharge',
    method: 'post',
    data: data
  });
}

// 会员兑换
function memberExchange(data) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/exchange',
    method: 'post',
    data: data
  });
}

// 同步会员信息
function syncMember(userId) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/SyncUserInfo',
    method: 'get',
    params: {
      userId: userId
    }
  });
}

// 发放优惠券
function sendCoupon(data) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/sendCoupon',
    method: 'post',
    data: data
  });
}

// 解绑会员卡信息
function unbindMember(userId) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/unbindCard',
    method: 'delete',
    params: {
      userId: userId
    }
  });
}
// 解绑微信openid
function unbindOpenId(openId, userId) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/unbindOpenId',
    method: 'delete',
    params: {
      userId: userId,
      openId: openId
    }
  });
}
// 导出会员列表
function exportMembers(query) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/uploadFile',
    method: 'get',
    params: query
  });
}

// 上传头像
function uploadAvatar(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/xyUsers/uploadPicAddOrUpd',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 获取图片资源前缀
function getImagePrefix() {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/getResPath',
    method: 'get'
  });
}

// 获取储值记录分页
function xyUserAccountPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAccount/page',
    method: 'get',
    params: query
  });
}

// 导出储值记录
function exportRechargeRecords(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAccount/uploadFile',
    method: 'get',
    params: query
  });
}
// 撤销储值
function retRecharge(id) {
  return (0, _requestAuth.default)({
    url: "/xyUserAccount/retRecharge/".concat(id),
    method: 'get'
  });
}
// 确认储值记录
function confirmRecharge(id) {
  return (0, _requestAuth.default)({
    url: "/xyUserAccount/confirmRecharge/".concat(id),
    method: 'get'
  });
}
// 支付确认储值记录
function payRecharge(id) {
  return (0, _requestAuth.default)({
    url: "/xyUserAccount/payRecharge/".concat(id),
    method: 'get'
  });
}
// 退款
function retMoney(id) {
  return (0, _requestAuth.default)({
    url: "/xyUserAccount/retMoney/".concat(id),
    method: 'get'
  });
}

// 获取用户地址分页
function xyUserAddressPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAddress/page',
    method: 'get',
    params: query
  });
}

// 删除用户地址
function deleteXyUserAddress(addressId) {
  return (0, _requestAuth.default)({
    url: '/xyUserAddress',
    method: 'delete',
    params: {
      addressId: addressId
    }
  });
}

// 获取用户账户金额明细分页
function xyUserAccountLogPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAccountLog/page',
    method: 'get',
    params: query
  });
}

// 获取用户积分变动明细分页
function xyBonusLogPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyBonusLog/pageBonusCdp',
    method: 'get',
    params: query
  });
}

// 获取用户发券列表分页
function xyUserCouponBatchPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserCouponBatch/page',
    method: 'get',
    params: query
  });
}

// 获取用户扩展信息汇总分页
function xyUserExtendPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserExtend/page',
    method: 'get',
    params: query
  });
}

// 获取用户日志列表分页
function xyUserActionPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAction/page',
    method: 'get',
    params: query
  });
}

// 获取注销列表
function getCancellationList(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserCleanup/page',
    method: 'get',
    params: query
  });
}

// 添加注销申请
function addCancellationItem(data) {
  return (0, _requestAuth.default)({
    url: '/xyUserCleanup',
    method: 'post',
    data: data
  });
}

// 审核注销申请
function approveCancellation(id) {
  return (0, _requestAuth.default)({
    url: '/xyUserCleanup/audit',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 查看会员券信息
function vipCouponInfo(params) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/vipCouponInfo',
    method: 'get',
    params: params
  });
}

// 导出用户地址
function exportUserAddresses(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserAddress/uploadFile',
    method: 'get',
    params: query
  });
}

// 通过手机号右模糊搜索用户（通用组件用）
function searchUserByPhone(phone) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/searchByPhone',
    method: 'get',
    params: {
      phone: phone
    }
  });
}